import React, {Component} from 'react';
import {connect} from 'react-redux';
import {SearchInput} from "../../components/search-bar/SearchInput";
import {push} from "react-router-redux";
import {searchLoading, searchString, setSearchResult, updateSearchParams} from "../../redux/action/search_actions";
import {SearchItem} from "../../components/item/SearchItem";
import {Spinner} from "../../components/spinner/Spinner";
import {BasicAnimation} from "../../components/animations/BasicAnimation";

class SearchViewContainer extends Component {


  constructor(props) {
    super(props);

    this.state = {
      search: []
    };

    this.search_param = this.props.location.search
      .substring(1)
      .split('&')
      .map( v => {
        const values = v.split('=');
        return {
          key: values[0],
          value: values[1]
        };
      })
      .find( v => v.key === 'v');

    if(this.search_param){
      if(this.search_param.value !== this.props.search_str){
        this.props.setSearchString(this.search_param.value);
        this.props.updateSearchParams(this.search_param.value);
      }
    }

  }

  componentWillReceiveProps(nextProps){
    if(this.props.location.search !== nextProps.location.search){
      // Scroll to top every time search changes
      window.scrollTo(0,0);

      this.setState({
        search: []
      });
    }
  }

  render(){
    const search_results = this.props.result && this.props.result
      .map( ( result, index ) => {
        return (
          <BasicAnimation duration={400} delay={0}>
          <SearchItem key={index}
                      attributes={{
                        onClick: event => this.productPressed(event, result),
                        className: 'pointer'
                      }}
                      title={result.post_title}
                      image={result.thumbnail}/>
          </BasicAnimation>
        );
      });

    return (
      <div className={"search-view-container"}>

        <div className={"search-view-input"}>
          <SearchInput updateFromParamChange
                       updateUrl
                       resultPath="searchView"
                       innerRef={ el => el && el.focus() }/>
        </div>
        <div className={"search-view-results"}>
          {
            this.props.loading
              ? <Spinner/>
              : search_results
          }
        </div>
      </div>
    );
  }

  productPressed(event, result){
    const solution = result.product_categories.find(p => p.parent === 0);

    if(solution !== -1){
      this.props.changeLocation("/solutions/" + solution.slug + "/products/" + result.post_name);
      event.preventDefault();
    }

  }
}

export const SearchView = connect(
  state => ({
    result: state.search.result.searchView,
    search_str: state.search.value,
    wpapi: state.WPAPI.instance,
    loading: state.search.loading
  }),
  dispatch => ({
    changeLocation: location => dispatch(push(location)),
    setSearchResult: result => dispatch(setSearchResult(result)),
    searchLoading: loading => dispatch(searchLoading(loading)),
    setSearchString: s_str => dispatch(searchString(s_str)),
    updateSearchParams: param => dispatch(updateSearchParams(param))
  })
)(SearchViewContainer);



// WEBPACK FOOTER //
// ./src/views/search/SearchView.js